module.exports = __webpack_public_path__ + "static/media/report.91c3a78f.svg";